import Head from 'next/head'

import IndentedList from '../components/IndentedList'
import Layout from '../components/Layout'

export default function Need(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | What You Need</title>
      </Head>
      <h1 className="mb-4 text-center text-2xl font-semibold">What You Need</h1>
      <div className="space-y-4">
        <p className="font-bold">
          Please let me know if any health problems arise between now and the
          Bris. This includes jaundice, which your baby's doctor may not be
          concerned about.
        </p>
        <section>
          <h2 className="mb-2 text-lg font-bold">Please Purchase</h2>
          <IndentedList>
            <li>Twenty 3" x 3" gauze squares</li>
            <li>A tube of Vaseline</li>
            <li>
              Kosher sweet wine (such as Manischewitz concord grape. The sugar
              calms the baby)
            </li>
            <li>A pacifier (optional)</li>
          </IndentedList>
        </section>
        <section>
          <h2 className="mb-2 text-lg font-bold">Have on hand for the Bris</h2>
          <IndentedList>
            <li>
              A regular size bed pillow (if the bris is at the synagogue that
              has a Chair of Elijah, you don't need a pillow)
            </li>
            <li>A nice wine glass or Kiddush cup</li>
            <li>
              A table and two chairs where we will be conducting the ceremony
            </li>
            <li>
              A private space where I can prepare before the ceremony (with a
              table or changing table)
            </li>
            <li>
              Good lighting both where I will be prepping and where we are doing
              the ceremony
            </li>
          </IndentedList>
        </section>
        <section>
          <h2 className="mb-2 text-lg font-bold">
            For the ceremony please assign
          </h2>
          <IndentedList>
            <li>
              Sandek
              <IndentedList listStyle="list-circle">
                <li>
                  This is the person who symbolically holds the baby during the
                  Bris
                </li>
                <li>This should not be a parent</li>
              </IndentedList>
            </li>
            <li>
              Kvatter and Kvatterin
              <IndentedList listStyle="list-circle">
                <li>
                  Two people to carry the baby into the room. Traditionally a
                  married couple but it doesn't need to be.
                </li>
                <li>These should not be the parents</li>
              </IndentedList>
            </li>
            <li>
              Four people to do English readings (if we are using my ceremony)
            </li>
            <li>
              There are also special readings for the grandparents and the
              parents
            </li>
            <li>
              Kvatter, Kvatterin, Sandek and at least one of the readers should
              be assigned to Jews. It is ideal to have a Minyan (10 Jews)
              present, but not required.
            </li>
          </IndentedList>
        </section>
        <section>
          <h2 className="mb-2 text-lg font-bold">Other Instructions</h2>
          <IndentedList>
            <li>Please feed the baby 30-60 minutes before the ceremony</li>
            <li>
              If you don't have a Rabbi or Cantor I am happy to conduct the ceremony
              myself. If you don't belong to a synagogue but are considering
              one, a Bris is a nice opportunity to develop a relationship with a
              Rabbi or Cantor, which can flourish for many years to come.
            </li>
          </IndentedList>
        </section>
      </div>
    </Layout>
  )
}
